module.exports = __webpack_public_path__ + "img/3-on.448a31ed.png";